import * as React from 'react';

import {
  pluginsConfig,
  allTypeMappers,
  ContentViewer,
} from '@wix/social-groups-common/dist/src/components/ContentEditor';

import { RawDraftContentState } from 'draft-js';

import { MembersActions, withSiteMembers } from '../Context';
import { compose } from '@wix/social-groups-common/dist/src/compose';
import { MentionedMember } from './MentionedMember';
import { MENTION_TYPE } from 'wix-rich-content-plugin-mentions/dist/module.viewer.cjs';
import { GALLERY_TYPE } from 'wix-rich-content-plugin-gallery';

import { theme } from '@wix/social-groups-common/dist/src/components/ContentEditor/theme';

interface PostContentViewerProps {
  contentState: RawDraftContentState;
}

type ComponentProps = PostContentViewerProps & MembersActions;
const typeMappers = allTypeMappers();

class PostContentViewerComponent extends React.Component<ComponentProps> {
  config = {
    ...pluginsConfig,
    [MENTION_TYPE]: {
      onMentionClick: (mention: MentionedMember) =>
        this.props.openUserProfile(mention.id),
      getMentionLink: () => {},
    },
  };

  render() {
    const { contentState } = this.props;

    // TODO investigate why gallery broke for galleryLayout === 3
    for (const entityId in contentState.entityMap) {
      const { type, data } = contentState.entityMap[entityId];

      if (type !== GALLERY_TYPE) {
        continue;
      }

      contentState.entityMap[entityId].data.styles = {
        ...data.styles,
        galleryLayout: 2,
      };
    }

    return (
      <ContentViewer
        theme={theme}
        config={this.config}
        typeMappers={typeMappers}
        initialState={contentState}
      />
    );
  }
}

const enhance = compose(withSiteMembers);

export const PostContentViewer = enhance(PostContentViewerComponent);
